import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=6221e1f2"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports